import { Link } from "react-router-dom";

function AboutPage() {
  return (
    <main className="section">
      <div className="container">
        <h1 className="title is-2 mb-4">Environmental, Health, and Safety</h1>
        <h2 className="subtitle is-4 mt-2 mb-6">Supra Opus</h2>

        <div className="content">
          <section className="mb-6">
            <h3 className="title is-4 mt-5 mb-3">Who We Are</h3>
            <p>
              Supra Opus provides Environmental Health &amp; Safety consulting and software. Founded by Brian Jones, MPH, we build and run compliant programs for manufacturing, construction, and healthcare.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="title is-4 mt-5 mb-3">What We Do</h3>
            <p>
              We help businesses in <strong>warehousing, manufacturing, construction, and healthcare</strong> navigate today's complex safety and compliance landscape. Our services include:
            </p>
            <ul>
              <li><strong>Workplace Safety Audits &amp; Assessments</strong> — identifying hazards and improvement opportunities.</li>
              <li><strong>Compliance Training &amp; Program Development</strong> — OSHA, EPA, and state-specific mandates such as California SB 553 Workplace Violence Prevention.</li>
              <li><strong>Incident Reporting &amp; EHS Software Solutions</strong> — streamlining how organizations capture, track, and resolve safety issues.</li>
              <li><strong>Strategic Consulting</strong> — designing long-term safety strategies that align with operational and regulatory goals.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h3 className="title is-4 mt-5 mb-3">Why It Matters</h3>
            <p>
              Regulatory compliance isn't just about avoiding fines — it's about protecting people, improving productivity, and creating trust within your workforce. From a <strong>32% reduction in injury rates</strong> achieved in logistics operations, to developing <strong>ergonomic and workplace violence prevention programs</strong> in fast-paced environments, we've seen how proactive safety transforms organizations.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="title is-4 mt-5 mb-3">Our Mission</h3>
            <p>
              To empower organizations of all sizes to move beyond "paper plans" and build <strong>living safety programs</strong> that protect people, meet compliance obligations, and support long-term growth.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="title is-4 mt-5 mb-3">Next Steps</h3>
            <p>
              We <strong>value</strong> safety, integrity, innovation, and collaboration. Ready to build a safer workplace? <strong>Contact us for a consultation by visiting our <Link to="/contact">Contact Us</Link> page.</strong>
            </p>
          </section>
        </div>

        <div className="has-text-centered mt-6 pt-4">
          <div className="mb-5">
            <img 
              className="is-rounded" 
              src="/images/AboutUs/brian.jpg" 
              alt="Brian Jones, MPH - Founder and Principal Consultant"
              width="150"
              height="150"
              style={{display: 'block', margin: '0 auto'}}
            />
          </div>
          <div className="mt-4">
            <h4 className="title is-5 mb-1" style={{marginBottom: '0.5rem'}}>Brian Jones, MPH</h4>
            <p className="has-text-grey" style={{fontSize: '1rem', marginTop: '0.5rem'}}>Founder and Principal Consultant</p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default AboutPage;
